import React from "react";
import NewHrmApp from "./newHrm/NewHrmApp";

const HRM = () => {
  return <NewHrmApp />;
};

export default HRM;
